import {CUSTOM_ELEMENTS_SCHEMA, ModuleWithProviders, NgModule} from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatMenuModule } from '@angular/material/menu';
import { MatButtonModule } from '@angular/material/button';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { AuthGuard } from './auth/auth.guard';
import { LoginRouterComponent } from './auth/login-router.component';

@NgModule({
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        RouterModule,
        NgbModule,
        MatToolbarModule,
        MatButtonModule,
        MatMenuModule,
        HeaderComponent,
        FooterComponent,
        LoginRouterComponent
    ],
    exports: [
        HeaderComponent,
        FooterComponent,
        MatButtonModule,
        MatToolbarModule,
        MatMenuModule
    ],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA
    ],
    providers: []
})

export class GlobalModule {
  static forRoot(): ModuleWithProviders<GlobalModule> {
    return {
      providers: [
        AuthGuard
      ],
      ngModule: GlobalModule
    };
  }
}
